import { Box, Button, Flex } from '@hausgold/designsystem';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { ApiContext, WizardContext } from 'fw-utils/contexts';
import {
  getBackButtonText,
  getNextButtonText,
} from '../../../services/models/dialog';

/**
 * Adds custom navigation buttons in different color and element states.
 * @param {number} currentStepIndex Returns the number of the step you are currently in
 * @param {string} nextStepKey Returns the previous step key. If not given than render as button and type submit.
 * @param {function} handlePreviousButtonClick On click functionality that ensures you can go back a step
 * @param {function} handleNextButtonClick On click functionality that ensures you can take a step forward
 */
const CustomNavigationButtons = ({
  currentStepIndex,
  nextStepKey,
  handlePreviousButtonClick,
  handleNextButtonClick,
}) => {
  const { data } = useContext(ApiContext);
  const {
    components: { NavigationButtonsLayoutContainer },
  } = useContext(WizardContext);

  return (
    <NavigationButtonsLayoutContainer flexDirection="column">
      <Box textAlign="center" />
      <Box width="100%">
        <Flex
          width="100%"
          justifyContent={currentStepIndex >= 0 ? 'space-between' : 'flex-end'}
          mb={4}
        >
          {currentStepIndex >= 0 && (
            <Button
              variant="outline"
              colorScheme="blue"
              as="a"
              className="back"
              onClick={handlePreviousButtonClick}
            >
              {getBackButtonText(data)}
            </Button>
          )}
          <Button
            colorScheme="red"
            backgroundColor="rgb(244, 99, 100)"
            borderColor="rgb(244, 99, 100)"
            as={nextStepKey ? 'a' : 'button'}
            type={nextStepKey ? null : 'submit'}
            className="next"
            onClick={handleNextButtonClick}
          >
            {getNextButtonText(data)}
          </Button>
        </Flex>
      </Box>
    </NavigationButtonsLayoutContainer>
  );
};

CustomNavigationButtons.propTypes = {
  currentStepIndex: PropTypes.number.isRequired,
  nextStepKey: PropTypes.string.isRequired,
  handlePreviousButtonClick: PropTypes.func.isRequired,
  handleNextButtonClick: PropTypes.func.isRequired,
};

export default CustomNavigationButtons;
